export enum ESupportProgramTheme {
  TEAL = 'TEAL',
  DARK = 'DARK',
  GOLD = 'GOLD',
}

export enum ESupportProgramIcon {
  GIFT = 'GIFT',
  AWARD = 'AWARD',
  SPARKLES = 'SPARKLES',
  TRUCK = 'TRUCK',
  HANDSHAKE = 'HANDSHAKE',
}

export type TSupportProgram = {
  id: number
  eyebrow: string | null
  title: string
  description: string | null
  ctaLabel: string | null
  ctaTarget: string | null
  ctaTargetLabel: string | null
  theme: ESupportProgramTheme
  iconName: ESupportProgramIcon
  sortOrder: number
  isActive: boolean
  activeFrom: string
  activeTo: string
  isVisibleNow: boolean
  createdAt: string
  updatedAt: string
}

export type TCreateSupportProgram = {
  eyebrow?: string | null
  title: string
  description?: string | null
  ctaLabel?: string | null
  ctaTarget?: string | null
  theme: ESupportProgramTheme
  iconName: ESupportProgramIcon
  sortOrder?: number
  isActive?: boolean
  activeFrom: string
  activeTo: string
}

export type TUpdateSupportProgram = Partial<TCreateSupportProgram>

export type TQuerySupportProgram = {
  page: number
  limit: number
  isActive?: boolean
}
